/** @type {'loadedmetadata' | 'loadstart' | 'canplay' | 'ready' | 'ended' | 'play' | 'pause' | 'error' | 'timeupdate'} */
var VideoEvents;

/** @type {'exists' | 'loaded' | 'error'} */
var ScriptDownloadResult;

export const BRIGHTCOVE = {
  ACCOUNT: {
    ID: '2830693144001',
  },
  AEM: {
    SINGLE_PLAYER_ID: '2834081556001',
    PLAYLIST_BELOW_ID: '3389842834001',
    PLAYLIST_RIGHT_ID: '3442084080001',
    LIVE_PLAYER_ID: '3442084083001',
  },
  SCRIPT: {
    DEFAULT_ID: '8d914a8e-0772-4b65-b040-afb00fc98328',
    PLAYLIST_BELOW_ID: 'd764922f-fc55-471d-b285-794b7894e184',
    PLAYLIST_RIGHT_ID: '51816009-6df9-4c29-820a-b296f729c9a9',
  },
};

/**
 * Brightcove player helper.
 */
export class BrightcovePlayerService {
  constructor() {
    this.player = null;
  }

  /**
   * Allows to invoke callback on specific video event.
   * @param {VideoEvents} event List of all events: https://docs.brightcove.com/brightcove-player/current-release/Player.html#event:beforepluginsetup:$name
   * @param {Function} callback Callback function.
   * */
  onVideo(event, callback) {
    if (!this.player) return;
    this.player.on(event, callback);
  }

  /**
   * Replay video.
   * @param {Boolean} muted Allows to play muted video.
   * */
  replayVideo() {
    this.player.currentTime(0);
    this.playVideo();
  }

  /**
   * Pasue video.
   * @param {Boolean} muted Allows to play muted video.
   * */
  playVideo(muted = false) {
    this.player.muted(muted);
    this.player.play();
  }

  /**
   * Pasue video.
   * */
  pauseVideo() {
    this.player.pause();
  }

  /**
   * Should be invoked when brightcove script is already available.
   * @param {String} hookElementId ID of the HTML element where player should be mounted.
   * */
  preparePlayer(hookElementId) {
    if (!window.videojs) return;
    this.player = window.videojs.getPlayer(hookElementId);
    this.player.ready();
  }

  /**
   * The script should be downloaded and executed only when <video></video> placeholder is already attached to the HTML body.
   * Brightcove script will try to find all the <video> tags with needed properties and register them.
   * https://player.support.brightcove.com/getting-started/step-step-brightcove-player.html
   * @param {String} scriptUrl ID of the HTML element where player should be mounted.
   * @returns {Promise<ScriptDownloadResult>} scriptUrl ID of the HTML element where player should be mounted.
   */
  async downloadBrightcoveScript(scriptUrl) {
    const scriptAlreadyExists = url => !!document.head.querySelector(`script[src="${url}"]`);

    if (scriptAlreadyExists(scriptUrl)) return Promise.resolve('exists');

    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.setAttribute('src', scriptUrl);
      script.setAttribute('type', 'text/javascript');
      script.setAttribute('defer', 'defer');

      script.onload = () => resolve('loaded');
      script.onerror = () => reject('error');

      document.head.append(script);
    });
  }
}